<template>
    <div>
        <MercenaryHeader v-if="step !== 3" :isBlur="true" :title="''" :back-title="'뒤로가기'" :close-action="closeAction"></MercenaryHeader>
        <div v-show="step === 0" style="flex:1; display:flex; flex-direction: column;">
            <div style="flex:1;">
                <div style="display:flex; justify-content: center; align-items: center; flex-direction: column;">
                    <div style="height:60px;"></div>
                    <img :src="require('@/assets/img/parent_auth_lcok.png')" style="width:91px;">
                    <div style="font-size:20px; font-weight:bold; margin-top:20px;">미성년자 회원은</div>
                    <div style="font-size:20px; font-weight:bold; margin-top:10px;"><span style="color:#FF7111;">보호자 인증</span>이 필요해요</div>
                    <div style="color:#808080; font-size:14px; font-weight:500;text-align:center; line-height:20px;margin-top:5px;">부모님 인증을 완료하면<br>더 많은 입단 테스트 제안을 받을 수 있습니다.</div>
                </div>
                <div style="background: rgba(33, 15, 3, 0.05); padding:15px 24px; color:#210F03; font-size:14px; margin-top:30px;">
                    <div>다음 내용을 꼭 따라해주세요👀</div>
                    <div style="display:flex; gap:5px; margin-top:5px;">
                        <div style="line-height:24px;">1.</div>
                        <div style="line-height:24px;">[가족 허락받기] 버튼을 눌러 가족(부모님 및 법정대리인)임을 인증 받으세요.</div>
                    </div>
                    <div style="display:flex; gap:5px;">
                        <div style="line-height:24px;">2.</div>
                        <div style="line-height:24px;">가족(부모님 및 법정대리인)의 성함과 연락처를 입력해주세요.</div>
                    </div>
                    <div style="display:flex; gap:5px;">
                        <div style="line-height:24px;">3.</div>
                        <div style="line-height:24px;">메시지로 전송된 '부모님 인증'을 확인해달라고 전달하세요.</div>
                    </div>
                    <div style="display:flex; gap:5px;">
                        <div style="line-height:24px;">4.</div>
                        <div style="line-height:24px;">가족(부모님 및 법정대리인)이 인증을 완료하면 끝이에요.</div>
                    </div>
                </div>
                <div>
                    <div style="text-decoration: underline; color: #606060; padding:10px; font-size:14px; font-weight:500; text-align:center; margin-top:20px;" @click="authenticateNextTime">다음에 부모님 인증받기</div>
                </div>
            </div>
            <div style="text-align:center;">
                <div style="font-size:14px; font-weight:bold; color:#FF7111;">사커하우</div>
                <div style="font-size:10px;margin-top:3px;">사커하우 유소년 가족 인증 서비스</div>
            </div>
            <div style="padding:20px;">
                <div style="background-color: #210F03;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#FF7111;" @click="goNext(1)">가족 허락받기</div>
            </div>
        </div>
        <div v-show="step === 1" style="flex:1; display:flex; flex-direction: column;">
            <div style="flex:1; display:grid;place-items: center; padding:10px;">
                <div style="width:100%;">
                    <div style="text-align:center;color:#210F03; font-size:20px; font-weight:bold; line-height:30px;">부모님 혹은 법정대리인의<br>본인 확인이 필요해요</div>
                    <div style="background: rgba(33, 15, 3, 0.05); border-radius:12px; padding:10px;margin-top:20px;">
                        <div style="color:#210F03; font-size:12px; font-weight:500;">부모님 및 법정대리인</div>
                        <div style="margin-top:10px;">
                            <input type="text" placeholder="이름"  style="border:0px;background: transparent;font-size:18px; width:100%;" v-model="name">
                        </div>
                    </div>
                    <div style="background: rgba(33, 15, 3, 0.05); border-radius:12px;  padding:10px;margin-top:10px;">
                        <div style="color:#210F03; font-size:12px; font-weight:500;">전화번호</div>
                        <div style="margin-top:10px;">
                            <input type="tel" placeholder="숫자만 입력하세요" style="border:0px;background: transparent;font-size:18px; width:100%;" v-model="phone" maxlength="13" ref="phone_input">
                        </div>
                    </div>
                    <div style="color:#606060; text-align:center; margin-top:10px; font-size:12px; font-weight:500;">가족 인증은 딱 한번만 하면 됩니다!</div>
                </div>
            </div>
            <div style="text-align:center;">
                <div style="font-size:14px; font-weight:bold; color:#FF7111;">사커하우</div>
                <div style="font-size:10px;margin-top:3px;">사커하우 유소년 가족 인증 서비스</div>
            </div>
            <div style="padding:20px;">
                <div v-if="name.length > 0 && phone.length === 13" style="background-color: #210F03;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#FF7111;" @click="sendAuthNumber(false)">인증하기</div>
                <div v-else style="background-color: #EBEBEB;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#D9D9D9;">인증하기</div>
            </div>
        </div>
        <div v-show="step === 2" style="flex:1; display:flex; flex-direction: column;">
            <div style="flex:1; display:grid;place-items: center; padding:20px;">
                <div style="width:100%;text-align:center;">
                    <div style="color:#210F03; font-size:20px; font-weight:bold; line-height:30px;">부모님 휴대폰으로 전송된<br><span style="color:#FF7111">인증번호</span>를 입력해 주세요.</div>
                    <div style="line-height:20px; font-size:14px; font-weight:500; color:#808080; margin-top:20px;">입력하신 <span style="font-size:15px; font-weight: bold; color:#210F03;">{{phone}}</span> 번호로<br>6자리 숫자가 발송되었습니다.</div>
                    <div style="background: rgba(33, 15, 3, 0.05); border-radius:12px; padding:10px; margin-top:15px;">
                        <input type="number" placeholder="인증코드"  style="border:0px;background: transparent;font-size:18px; width:100%;" v-model="auth_number" maxlength="6">
                    </div>
                    <div style="color:#808080; font-size:14px;">인증번호가 오지않았나요? <div style="display:inline-block; text-decoration: underline; margin-top:10px; color:#210F03; padding:5px;" @click="sendAuthNumber(true)">인증번호 재전송</div></div>
                </div>
            </div>
            <div style="text-align:center;">
                <div style="font-size:14px; font-weight:bold; color:#FF7111;">사커하우</div>
                <div style="font-size:10px;margin-top:3px;">사커하우 유소년 가족 인증 서비스</div>
            </div>
            <div style="padding:20px;">
                <div style="background-color: #210F03;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#FF7111;" @click="authenticate">다음</div>
            </div>
        </div>
        <div v-show="step === 3" style="flex:1; display:flex; flex-direction: column;">
            <div style="flex:1; display:grid; place-items: center;">
                <div style="text-align:center;">
                    <img :src="require('@/assets/img/parent_auth_complete.png')">
                    <div style="color:#210F03; font-weight:bold; font-size:20px; margin-top:30px;">부모님 인증이 완료됐습니다</div>
                </div>

            </div>
            <div style="padding:20px;">
                <div style="background-color: #210F03;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#FF7111;" @click="complete">다음</div>
                <!--<div style="background-color: #EBEBEB;height:48px; border-radius:12px; display:grid;place-items: center; font-size:16px; font-weight:bold; color:#D9D9D9;">다음</div>-->
            </div>
        </div>
        <div v-if="is_show_elite_next_popup" style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0, 0, 0, 0.3); display:grid; place-items: center;">
            <div style="width:350px; padding:22px; background-color: white; border-radius:24px;">
                <div style="font-size:20px; font-weight:bold;text-align:center; line-height:28px; ">앗, 엘리트 선수는<br>부모님 인증이 꼭 필요해요!</div>
                <div style="color:#FF7111; font-size:14px; font-weight:bold;text-align:center; margin-top:10px;">확실한 신원 확인과 보호를 위해,</div>
                <div style="font-weight:500; font-size:14px; color:#808080;text-align:center; margin-top:10px;">부모님 인증없이는 입단 요청서 작성이 어려워요!</div>
                <div style="display:flex; margin-top:20px; gap:15px;">
                    <div style="flex:3;background-color:#D9D9D9; font-weight:bold; color:#210F03; font-size:12px; border-radius:12px; height:48px; display:grid; place-items: center;" @click="goToSoccerTeamJoinPage()">나가기</div>
                    <div style="flex:7;background-color:#FF7111; font-weight:bold; color:white; font-size:12px; border-radius:12px; height:48px; display:grid; place-items: center;" @click="() => {is_show_elite_next_popup = false; goNext(1)}">지금 인증할게요</div>
                </div>
            </div>
        </div>
        <div v-if="is_show_challenger_next_popup" style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0, 0, 0, 0.3); display:grid; place-items: center;">
            <div style="width:350px; padding:22px; background-color: white; border-radius:24px;">
                <div style="font-size:20px; font-weight:bold;text-align:center; line-height:28px; ">정말 부모님 인증없이<br>입단 요청서를 작성하시겠어요?</div>
                <div style="font-weight:500; font-size:14px; color:#808080;text-align:center; margin-top:10px;">부모님 인증을 완료하시면 뱃지가 부여되며,</div>
                <div style="color:#FF7111; font-size:14px; font-weight:bold;text-align:center; margin-top:10px;">감독님들께 더 높은 신뢰<span style="color:#808080;font-weight:500; ">를 줄 수 있어</span></div>
                <div style="color:#FF7111; font-size:14px; font-weight:bold;text-align:center; margin-top:10px;">스카우트 연락을 받을 가능성이 더욱 높아져요!</div>
                <div style="display:flex; margin-top:20px; gap:15px;">
                    <div style="flex:3;background-color:#D9D9D9; font-weight:bold; color:#210F03; font-size:12px; border-radius:12px; height:48px; display:grid; place-items: center;" @click="nextStep">나중에 할게요</div>
                    <div style="flex:7;background-color:#FF7111; font-weight:bold; color:white; font-size:12px; border-radius:12px; height:48px; display:grid; place-items: center;" @click="() => {is_show_challenger_next_popup = false;goNext(1)}">지금 인증할게요</div>
                </div>
            </div>
        </div>
        <div @click="isShowWritePopup = false" v-if="isShowWritePopup" style="position:fixed; left:0px; top:0px; width:100%; height:100%; background-color: rgba(0, 0, 0, 0.3); display:grid; place-items: center;">
            <div @click.stop style="width:366px; padding:22px; background-color: white; border-radius:24px;">
                <div style="font-size:20px; font-weight:bold;text-align:center; line-height:28px; ">언제든 부모님 인증을 받을 수 있어요! 😉</div>
                <div style="color:#FF7111; font-size:14px; color: #808080; line-height: 24px; font-weight:500;text-align:center; margin-top:5px;">감독님들의 연락이 적거나,<br> 입단 요청서를 더 신뢰감 있고 멋지게 보여주고 싶다면<br><span style="font-weight:bold; color: var(--color-main);">부모님 인증을 추천드려요 ⚽</span></div>
                <div class="common_btn" @click="writeRequestForm">확인했어요</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TYPE} from "../soccerhowmain/SelectPlayerType";
    import MercenaryHeader from "../common/MercenaryHeader";
    export default {
        name: "ParentAuth",
        props : {
            completeAction : {
                type : Function,
                default : () => {}
            },
            selected_player_type : {
                type : [String, Number],
                default : -1
            },
            preparedFormData: {
                type: [FormData, Object],
                default: () => new FormData()
            },
            saveSoccerHowDraft: {
                type: Function,
                default: () => {}
            }
        },
        components: {MercenaryHeader},
        data(){
            return {
                step : 0,
                name : '',
                phone : '',
                auth_number : '',
                is_show_elite_next_popup : false,
                is_show_challenger_next_popup : false,
                isShowWritePopup : false,
            }
        },
        methods : {
            async makeRequestForm() {
                this.$GlobalStore.addModal('Loading', {
                    transitionName: '',
                    isModalBackTransparent: true,
                })
                let formData = null;
                formData = this.preparedFormData
                formData.append('is_deleted', false)

                const res = await this.$Axios.post('/api/soccerhow/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                if (res.data.code === 0) {
                    this.$GlobalStore.closeLastModal()
                    if (this.$GlobalStore.loginInfo().visit_reason === '축구선수 희망' || this.$GlobalStore.loginInfo().visit_reason === '축구 진로 상담' || this.$GlobalStore.loginInfo().visit_reason === '축구팀 입단') {
                        this.$Util.sendEventClick('축구팀입단_축구선수_희망_요청서작성', true)
                    } else {
                        this.$Util.sendEventClick("축구팀입단_요청서작성", true)
                    }
                    if (res.data.login_info) {
                        this.$GlobalStore.setLoginInfo(res.data.login_info)
                    }
                    if (res.data.first_parent_idx) {
                        this.$GlobalStore.closeModalAll();
                        this.$GlobalStore.addModal('RequestReportDetailNew', { soccerhowIdx: res.data.first_parent_idx, is_parent_verified: false })
                    } else {
                        this.closeRequestJoinForm(true)
                    }
                    return res
                }
                return null
            },
            writeRequestForm(){
                this.isShowWritePopup = false;
                this.$GlobalStore.closeLastModal();
                this.completeAction()
            },
            nextStep(){
                this.is_show_challenger_next_popup = false;
                this.isShowWritePopup = true;
            },
            goToSoccerTeamJoinPage(){
                this.saveSoccerHowDraft();
                this.$GlobalStore.closeModalAll();
                this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } })
            },
            authenticateNextTime(){
                if(this.selected_player_type === TYPE.ELITE){
                    this.is_show_elite_next_popup = true;
                } else if(this.selected_player_type === TYPE.CHALLENGER){
                    this.is_show_challenger_next_popup = true;
                } else {
                    this.$GlobalStore.closeLastModal();
                }
            },
            complete(){
                this.$GlobalStore.closeLastModal();
                this.completeAction();
            },
            goNext(step){
                this.step = step;
            },
            closeAction(){
                if(this.step === 0){
                    this.$GlobalStore.closeLastModal();
                } else {
                    this.step--;
                }
            },
            async sendAuthNumber(is_retry){
                if(this.$GlobalStore.loginInfo().phone === this.phone){
                    this.$GlobalStore.showAlert('회원가입 시 사용한 전화번호로는 보호자 인증이 불가능합니다.');
                    return;
                }
                const parameters = {};
                parameters.phone = this.phone;
                parameters.duple = "0";
                parameters.message_type = 'parent_auth';

                const res = await this.$Axios.post("/api/auth/number", parameters);
                if (res.data.code === 0) {
                    if(is_retry){
                        this.$GlobalStore.showAlert('재전송 되었습니다.');
                    }else{
                        this.step++;
                    }
                } else {
                    alert(res.data.msg);
                }
            },
            async authenticate(){
                const parameters = {};
                parameters.name = this.name;
                parameters.phone = this.phone;
                parameters.auth_number = this.auth_number;

                const res = await this.$Axios.post('/api/member/family/auth_by_phone', parameters);
                if(res.data.code === 0){
                    this.step = 3;
                }else if(res.data.code === -1){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async getParentExist(){
                const res = await this.$Axios.get('/api/member/family/exist');
                if(res.data.is_family_exist){
                    this.$GlobalStore.showAlert('이미 부모님 인증을 받았습니다.');
                    this.$GlobalStore.closeLastModal();
                }
            },
        },
        mounted(){
            this.$Util.setPhoneFormatter(this.$refs.phone_input);
        },
        created(){
            this.sendAuthNumber = this.$Once(this.sendAuthNumber);
            this.authenticate = this.$Once(this.authenticate);
            this.getParentExist();

        }
    }
</script>

<style scoped>
    input{-webkit-appearance: none; outline: none;}

    .common_btn{
        width: 188px;
        background-color:#FF7111;
        font-weight:bold;
        color:white;
        font-size:12px;
        border-radius:12px;
        height:48px;
        display:grid;
        place-items: center;
        margin: 0 auto;
        margin-top: 20px;
    }
</style>